import { render, staticRenderFns } from "./MargeUserDialog.vue?vue&type=template&id=6aa2572e&"
import script from "./MargeUserDialog.vue?vue&type=script&lang=js&"
export * from "./MargeUserDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports